<template>

    <div v-if="postingData || !dataLoaded || !editModeLoaded"><Loader/></div>

    <div class="create-preregistration" v-else-if="dataLoaded && editModeLoaded">

        <div class="header-steps">
            <div class="step" :class="{'step--selected':stepSelected== 1.1 || stepSelected == 1.2}"><i class="material-icons" v-if="stepSelected>1">check_circle</i><span v-else>1</span><span>Datos de la cohorte</span></div>
            <div class="step" :class="{'step--selected':stepSelected==2}"><i class="material-icons" v-if="stepSelected>2">check_circle</i><span v-else>2</span><span>Datos a solicitar</span></div>
            <div class="step" :class="{'step--selected':stepSelected==3}"><i class="material-icons" v-if="stepSelected>3">check_circle</i><span v-else>3</span><span>Charla informativa</span></div>
            <div class="step" :class="{'step--selected':stepSelected==4}"><i class="material-icons" v-if="stepSelected>4">check_circle</i><span v-else>4</span><span>Invitación</span></div>
        </div>

        <div v-if="stepSelected == 1.1" class="step-1-1">
            <div class="form-header">
                <h1>Crear preinscripción</h1>
                <h2>Paso 1</h2>
                <h3>Configuración de la cohorte</h3>
            </div>
            <div class="invalid-box-info" v-if="step1_1Invalid && submitted">
                <div><i class="material-icons">error</i></div>
                <div>
                    <div class="invalid-box-info__title">Datos obligatorios</div>
                    <div class="invalid-box-info__info">Completa los campos requeridos para continuar.</div>
                </div>
            </div>
            <div class="step-1-1__form">
                <Input 
                    label="Nombre"
                    placeholder="Ej. Tu Pasión Inspira"
                    v-model="dataModel.title"
                    id="nameOfCohort"
                    :isError="v$.dataModel.title.$invalid && submitted"
                    tooltipTitle="Nombre" 
                    tooltipMessage="Es el nombre con el que se identifica internamente a la inscripción." 
                />
                <Input 
                    label="Código de la inscripción"
                    placeholder="Ej. MEX-TPI-23-01"
                    v-model="dataModel.internalName"
                    id="internalName"
                    :isError="v$.dataModel.internalName.$invalid && submitted"
                    supportTextIcon="info"
                    tooltipTitle="Codigo de la inscripción" 
                    tooltipMessage="Es el nombre que verán los participantes en la plataforma e invitaciones." 
                />
                <Input 
                    label="Cupo"
                    placeholder="Ejemplo 50"
                    id="quota"
                    type="number"
                    v-model="dataModel.studentLimit"
                />
                <Select
                    mode="multi"
                    v-model="dataModel.countriesIds"
                    id="countriesIds"
                    :values="creationOptions.countries"
                    valueProp="id"
                    valueLabel="name"
                    label="Países"
                    :isDropdown="true"
                />
                <DatePicker
                    label="Fecha inicio de preinscripcion"
                    v-model="dataModel.startDate"
                    id="startDate"
                    :isError="v$.dataModel.startDate.$invalid && submitted" 
                    :from="new Date(new Date().setHours(0, 0, 0, 0))"
                    :selectToday="true"
                />
                <DatePicker
                    label="Fecha cierre de preinscripcion"
                    v-model="dataModel.endDate"
                    id="endDate"
                    :optional="true"
                    supportText="Podrás editar la fecha de cierre  en caso de necesitarlo."
                    supportTextIcon="info"
                    :from="new Date(dataModel.startDate)"
                />

                <!-- <h5>CIERRE DE INSCRIPCIÓN</h5>
                <div class="step-1-1__form__onClose">
                    <template v-for="(option,index) in behavioursOnClose" :key="index">
                        <div><input type="radio" id="onClose" :value="option.value" v-model="dataModel.behaviourOnClose"><label>{{option.value}}</label></div>
                    </template>
                </div> -->
            </div>
            <div style="padding-top: 36px;">
                <button class="btn-nextStep" @click.stop="submittStep1_1()" :disabled="step1Invalid && submitted"><span>Continuar</span><i class="material-icons">arrow_forward</i></button>
            </div>
            <!-- <div class="save-btn"><button>Guardar</button></div> -->
        </div>

        <div v-if="stepSelected == 1.2" class="step-1-2">
            <div class="form-header">
                <h1>Crear preinscripción</h1>
                <h2>Paso 1</h2>
                <h3>Datos adicionales de la cohorte</h3>
            </div>
            <div class="invalid-box-info" v-if="step1_2Invalid && submitted">
                <div><i class="material-icons">error</i></div>
                <div>
                    <div class="invalid-box-info__title">Datos obligatorios</div>
                    <div class="invalid-box-info__info">Completa los campos requeridos para continuar.</div>
                </div>
            </div>
            <div class="step-1-2__form">
                <Select
                    mode="simple" 
                    id="curseType" 
                    label="Tipo de curso"
                    :values="formattedCourseTypes"
                    valueLabel="name"
                    valueProp="id" 
                    v-model="dataModel.courseType" 
                    :isError="v$.dataModel.courseType.$invalid && submitted"
                    errorMessage="Este campo es requerido"
                    @update:modelValue="updateSelectCourses()"
                    :disabled="editingMode"
                />
                <Select
                    mode="simple" 
                    id="targetType" 
                    label="Público"
                    :values="formattedTargetTypes"
                    valueLabel="name"
                    valueProp="id" 
                    v-model="dataModel.targetType" 
                    :isError="v$.dataModel.targetType.$invalid && submitted"
                    errorMessage="Este campo es requerido"
                    @update:modelValue="updateSelectCourses()"
                    :disabled="editingMode"
                />
                <!-- <Select v-if="showSelectCourses"
                    v-model="dataModel.courses"
                    :isError="v$.dataModel.courses.$invalid && submitted"
                    mode="multi"
                    label="Curso"
                    valueProp="id"
                    valueLabel="internalName"
                    id="courses"
                    :values="creationOptions.courses.filter(course => course.courseType == dataModel.courseType)"
                    :isDropdown="true"
                    :style="{opacity: dataModel.courseType == null ? 0.5 : 1, pointerEvents: dataModel.courseType == null ? 'none' : 'all'}"
                /> -->
                <!-- style based on courseType and targetType -->
                 <!-- disabled if editingMode and courseType not on demand -->
                <Select v-if="showSelectCourses"
                    v-model="dataModel.courses"
                    :isError="v$.dataModel.courses.$invalid && submitted || !dataModel.courses && filteredCourses.length == 0"
                    mode="multi"
                    label="Curso"
                    valueProp="id"
                    valueLabel="internalName"
                    id="courses"
                    :values="filteredCourses"
                    :isDropdown="true"
                    :errorMessage="filteredCourses.length == 0 && 'No hay cursos disponibles para el tipo de curso y público seleccionado.' || v$.dataModel.courses.$invalid && submitted && 'Este campo es requerido'"
                    :disabled="editingMode && dataModel.courseType !== 0"
                />
                <!-- :style="{opacity: !dataModel.courseType || !dataModel.targetType ? 0.5 : 1, pointerEvents: !dataModel.courseType || !dataModel.targetType ? 'none' : 'all'}" -->
                <!-- :values="creationOptions.courses.filter(course => course.courseType == dataModel.courseType && course.targetType == dataModel.targetType)" -->
                 
                <Select 
                    v-model="dataModel.coordinators"
                    mode="simple"
                    id="coordinator"
                    label="Coordinador"
                    valueProp="id"
                    valueLabel="fullName"
                    :values="creationOptions.coordinators"
                    :isDropdown="true"
                />
                <Select 
                    v-model="dataModel.referents"
                    label="Gestores"
                    :values="creationOptions.referents"
                    id="referents"
                    valueProp="id"
                    valueLabel="fullName"
                    mode="multi"
                    supportTextIcon="info"
                    supportText="Podrás seleccionar más de un gestor."
                    :isDropdown="true"
                />
            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 1.1"><i class="material-icons">arrow_back</i>Atrás</button>
                <button @click.stop="submittStep1_2()" :disabled="step1_2Invalid && submitted">Continuar<i class="material-icons">arrow_forward</i></button>
            </div>
            <!-- <div class="save-btn"><button>Guardar</button></div> -->
        </div>

        <div v-if="stepSelected == 2" class="step-2">
            <div class="form-header">
                <h1>Crear preinscripción</h1>
                <h2>Paso 2</h2>
                <h3>Datos a solicitar en las etapas de inscripción</h3>
                <!-- <h4 :style="{textAlign: 'center'}">
                    Recuerda que el nombre, apellido y mail se solicitan de manera obligatoria en la etapa 1. <br />
                    Estos datos adicionales deben solicitarse en alguna de las dos etapas
                </h4> -->
                <div class="form-header__instructions" :class="{'disabled': editingMode}">
                    <i class="material-icons">near_me</i>
                    <span>Selecciona los datos que se solicitarán durante la inscripción.</span>

                </div>
            </div>
            <InformationRectangle 
                title="Datos obligatorios" 
                message="Es necesario seleccionar una categoría de inscripción" 
                background="#ffded7" 
                icon="error"
                color="#F57055"
                v-if="step2Invalid && submitted"
            />

            <!-- <div class="select-category-table">
                <div class="header">
                    <span></span>
                    <span v-for="(column,idx) in creationOptions.categoriesFields" :key="idx">{{ $t('preInscription.fields.' + column.propertyName.toUpperCase()) }}</span>
                </div>
                <div class="row"
                @click="dataModel.categoryId = row.id"
                v-for="(row,idx) in creationOptions.categories" :key="idx" :class="{'row__selected': row.id == dataModel.categoryId}">
                    <span class="row__name"><input type="radio" :disabled="editingMode" :value="row.id" v-model="dataModel.categoryId"></span>

                    <div class="row__name" @click="dataModel.categoryId = row.id">
                        <div class="row__name__check" :class="{'row__name__check--selected': row.id == dataModel.categoryId}">
                            <i class="material-icons" v-if="row.id == dataModel.categoryId">check</i>
                        </div>
                    </div>
                    <span v-for="field in creationOptions.categoriesFields" :key="field.propertyName">
                        <i class="material-icons" v-if="row.fields.some(obj => obj.propertyName === field.propertyName)">check</i>
                    </span>
                </div>
            </div> -->
            <table class="select-category-table" :class="{ 'noSelectedCategory': noSelectedCategory, 'disabled': editingMode }">
                <thead>
                    <tr class="header">
                        <th></th>
                        <th v-for="(column, idx) in creationOptions.categoriesFields" :key="idx">
                            {{ $t('preInscription.fields.' + column.propertyName.toUpperCase()) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                    v-for="(row, idx) in creationOptions.categories"
                    :key="idx"
                    :class="{'row__selected': row.id == dataModel.categoryId}"
                    @click="!editingMode && (dataModel.categoryId = row.id); noSelectedCategory = false"
                    >
                        
                        <!-- Instead of a radio button, use a check icon inside a div -->
                        <td>
                            <div class="row__name__check" :class="{'row__name__check--selected': row.id == dataModel.categoryId}">
                                <!-- <i class="material-icons" v-if="row.id == dataModel.categoryId">check</i> -->
                                 <span v-if="row.id == dataModel.categoryId"></span>
                            </div>
                        </td>
                        
                        <!-- Loop through category fields -->
                        <td v-for="field in creationOptions.categoriesFields" :key="field.propertyName">
                            <i class="material-icons" v-if="row.fields.some(obj => obj.propertyName === field.propertyName)">check</i>
                            <!-- <i class="material-icons" v-else>minimize</i> -->
                             <span v-else class="empty">-</span>
                        </td>
                    </tr>
                </tbody>
            </table>


        <!--<div class="stages" :class="{'editDisabled': editingMode && !canFullEdit }" >
                <div class="stages__labels">
                    <div class="stage-title"></div>
                    <label>Documento de identidad</label> 
                    <label>Género</label>
                    <label>País</label>
                    <label>Teléfono</label>
                    <label>Fecha de nacimiento</label> 
                    <label>Institución educativa</label>
                    <template v-for="(field,index) in dataModel.extraData" :key="index">
                        <div class="custom-field">
                            <span>{{field.name}}</span>
                            <i v-if="!editingMode" class="material-icons-outlined" @click.stop="editCustomField(field,index)">edit</i>
                            <i v-if="!editingMode" class="material-icons-outlined" @click.stop="modalDeleteCustomField.index=index; modalDeleteCustomField.active=true;">delete</i>
                        </div>
                    </template>
                    <div
                        @mouseover="!user.permissions.includes('PREINSCRIPCION_CUSTOMFIELD') ? toolTipsHover.customFields = true : null" 
                        @mouseleave="toolTipsHover.customFields = false"
                    >
                        <button :disabled="!user.permissions.includes('PREINSCRIPCION_CUSTOMFIELD')" class="btn-customField" @click.stop="resetCustomFieldModel();customFieldModel.modalActive=true">
                            + Agregar campo personalizado
                        </button> 
                        <button :disabled="true" class="btn-customField" @click.stop="resetCustomFieldModel();customFieldModel.modalActive=true">
                            + Agregar campo personalizado
                        </button>
                        <ToolTip v-if="toolTipsHover.customFields" title="CAMPOS PERSONALIZADOS" message="Para crear un campo personalizado deberas contactar a un Coordinador Pedagógico." />
                    </div>
                </div>
                <div class="firstStage">
                    <div class="stage-title">
                        <span>ETAPA 1</span>
                        <span>PREINSCRIPCIÓN</span>
                    </div>
                    <input type="checkbox" checked disabled class="greyed-out"> 
                    <input type="checkbox"  checked disabled class="greyed-out">
                    <input type="checkbox"  checked disabled class="greyed-out">
                    <input type="checkbox"  checked disabled class="greyed-out">
                    <input type="checkbox" checked disabled class="greyed-out"> 
                    <input type="checkbox" checked disabled class="greyed-out"> 
                    <template v-for="(field,index) in dataModel.extraData" :key="index">
                        <input type="checkbox" :checked="field.stage == 1" :disabled="!canFullEdit && editingMode"> 
                    </template>
                </div>

                <div class="secondStage">
                    <div class="stage-title">
                        <span>ETAPA 2</span>
                        <span>INSCRIPCIÓN</span>
                    </div>
                    <input type="checkbox" disabled> 
                    <input type="checkbox" disabled>
                    <input type="checkbox" disabled>
                    <input type="checkbox" disabled>
                    <input type="checkbox" disabled>
                    <input type="checkbox" disabled> 
                    <template v-for="(field,index) in dataModel.extraData" :key="index">
                        <input type="checkbox" :checked="field.stage == 2">
                    </template>
                </div>
            </div>-->
             <div class="next-back-btns">
                <button @click.stop="stepSelected = 1.2"><i class="material-icons">arrow_back</i>Atrás</button>
                <button @click.stop="submittStep2()" :disabled="step2Invalid && submitted">Continuar<i class="material-icons">arrow_forward</i></button>
            </div>
            <!-- <div class="save-btn"><button>Guardar</button></div> -->
        </div>

        <!-- <div v-if="stepSelected == 3" class="step-1-2">
            <div class="form-header">
                <h1>Crear preinscripción</h1>
                <h2>Paso 3</h2>
                <h3>Configura la charla Informativa</h3>
            </div>
            <div class="invalid-box-info" v-if="step3Invalid && submitted">
                <div><i class="material-icons">error</i></div>
                <div>
                    <div class="invalid-box-info__title">Datos obligatorios</div>
                    <div class="invalid-box-info__info">Completa los campos requeridos para continuar.</div>
                </div>
            </div>
            <div class="step-1-2__form" >
                <div class="place" v-for="(talk,index) in dataModel.talkData" :key="index">
                    <h4 style="font-size: 12px; display: flex; align-items: center; justify-content: space-between;">
                        CHARLA INFORMATIVA VIRTUAL #{{index + 1}} 
                        <i v-if="dataModel.talkData.length > 1" @click="deleteTalk(index)" class="material-icons" style="cursor: pointer; font-size: 20px;">delete</i>
                    </h4>
                    <Select 
                        v-model="talk.modality"
                        mode="simple"
                        id="modality"
                        label="Modalidad"
                        :values="['Presencial', 'Virtual']"
                    />
                    <Input 
                        id="linkZoom"
                        label="Link de zoom de la charla"
                        v-model="talk.talkLink"
                        :disabled="!canFullEdit && editingMode" 
                        :isError="(v$.dataModel.talkData.$each.$response.$errors[index].talkLink.find(err => err.$validator === 'isValidUrl') || v$.dataModel.talkData.$each.$response.$errors[index].talkLink.length) && submitted"
                        :errorMessage="v$.dataModel.talkData.$each.$response.$errors[index].talkLink.find(err => err.$validator === 'isValidUrl') && 'Debe ingresar un link válido'"
                    />
                    <DatePicker 
                        v-model="talk.talkDate"
                        label="Fecha de charla informativa"
                        id="talkDate"
                        :disabled="!canFullEdit && editingMode" 
                        :isError=" v$.dataModel.talkData.$each.$response.$errors[index].talkDate.length && submitted "
                        :from="new Date(new Date().setHours(0, 0, 0, 0))"
                    />
                    <template v-if="true">
                        <template v-if="!!dataModel.countriesIds.length">
                            <Input
                                v-for="(country, idxCountry) in dataModel.countriesIds" :key="idxCountry" 
                                v-model="talk.talkHour"
                                :label="`Horario ${creationOptions.countries.find(ctry => ctry.id === country)?.name}`"
                                type="time"
                                id="talkHour"
                                :gmtDate="creationOptions.countries.find(ctry => ctry.id === country)?.gmt"
                                :disabled="!canFullEdit && editingMode" 
                                :isError="v$.dataModel.talkData.$each.$response.$errors[index].talkHour.length && submitted"
                            />
                        </template>
                        <template v-else>
                            <Input
                                v-for="(country, idxCountry) in creationOptions.countries" :key="idxCountry" 
                                v-model="talk.talkHour"
                                :label="`Horario ${country.name}`"
                                type="time"
                                id="talkHour"
                                :gmtDate="country.gmt"
                                :disabled="!canFullEdit && editingMode" 
                                :isError="v$.dataModel.talkData.$each.$response.$errors[index].talkHour.length && submitted"
                            />
                        </template>
                    </template>
                    <template v-else>
                        <span class="place__title">LUGAR</span>
                        <div style="display: flex; flex-direction: column; gap: 18px;">
                            <div v-for="(country, idx) in dataModel.countriesIds.length" :key="idx" class="place">
                                <span class="place__title">{{ `CHARLA INFORMATIVA ${creationOptions.countries.find(country => country.id === dataModel.countriesIds[idx]).name.toUpperCase()}` }}</span>
                                <div style="display: flex; gap: 6px;">
                                    <DatePicker 
                                        label="Fecha"
                                        :id="`fecha${idx}`"
                                    />
                                    <Input 
                                        type="time"
                                        label="Hora"
                                        :id="`hora${idx}`"
                                    />
                                </div>
                                <Input 
                                    label="Lugar de la charla"
                                    :id="`place${idx}`"
                                />
                                <Input 
                                    label="Calle"
                                    :id="`street${idx}`"
                                />
                                <div style="display: flex; gap: 6px;">
                                    <Input 
                                        label="Número"
                                        :id="`number${idx}`"
                                        type="number"
                                    />  
                                    <Input 
                                        label="Localidad"
                                        :id="`location${idx}`"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <button @click="addNewTalk" style="text-align: center;" class="btn-customField">+ Agregar nueva charla</button>
            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 2"><i class="material-icons">arrow_back</i>Atrás</button>
                <button @click.stop="submittStep3()" :disabled="step3Invalid && submitted">Continuar<i class="material-icons">arrow_forward</i></button>
            </div>
        </div> -->
<!-- 
        <div v-if="stepSelected == 4" class="step-4">
            <div class="form-header">
                <h1>Crear nueva cohorte</h1>
                <h2>Paso 4</h2>
                <h3>Configura las invitaciones</h3>
            </div>
            <div class="invalid-box-info" v-if="step4Invalid && submitted" style="margin-bottom: -10px">
                <div><i class="material-icons">error</i></div>
                <div>
                    <div class="invalid-box-info__title">Datos obligatorios</div>
                    <div class="invalid-box-info__info">Completa los campos requeridos para continuar.</div>
                </div>
            </div>
            <div class="step-4__form" :class="{ 'editDisabled': !canFullEdit && editingMode }">
                <Input 
                    type="textarea"
                    label="CUERPO INVITACIÓN CHARLAS"
                    placeholder="Ejemplo: Te invitamos a participar de la charla informativa..."
                    :isError=" v$.dataModel.emailData.emailInfo.$invalid && submitted "
                    v-model="dataModel.emailData.emailInfo"
                    :disabled="!canFullEdit && editingMode" 
                />
                <Select 
                    v-model="dataModel.emailData.modalityId"
                    label="Modalidad"
                    :isError=" v$.dataModel.emailData.modalityId.$invalid && submitted "
                    valueProp="id"
                    valueLabel="name"
                    id="modality"
                    :disabled="!canFullEdit && editingMode" 
                    :values="creationOptions.modalities"
                    :isDropdown="true"
                />
                <Input 
                    v-model="dataModel.emailData.timeDedication"
                    label="Dedicación horaria semanal"
                    type="number"
                    id="timeDedication"
                    :disabled="!canFullEdit && editingMode" 
                />
                <Input 
                    v-model="dataModel.emailData.duration"
                    label="Duración total"
                    type="number"
                    placeholder="Semanas"
                    :disabled="!canFullEdit && editingMode" 
                    id="duration"
                />
                <DatePicker 
                    v-model="dataModel.emailData.courseStartDate"
                    label="Fecha de inicio del curso"
                    id="courseStartDate"
                    :disabled="!canFullEdit && editingMode" 
                    :from="new Date(dataModel.startDate)"
                />
            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 3"><i class="material-icons">arrow_back</i>Atrás</button>
                <button @click.stop="submittStep4()" :disabled="step4Invalid && submitted">Continuar<i class="material-icons">arrow_forward</i></button>
            </div>
        </div> -->

        <div v-if="stepSelected == 5" class="step-5">
            <div class="form-header">
                <h1>Ya casi estamos</h1>
                <h2>CONFIRMACIÓN</h2>
                <h3>Revisa que la información sea correcta.</h3>
            </div>
            <div class="step-5__resume">
                <h3>DATOS DE LA COHORTE <span @click="stepSelected = 1.1">Editar <i class="material-icons">edit</i></span></h3>
                <div class="step-5__resume__step-1-1">
                    <div>
                        <div>
                            <label>Nombre de la cohorte</label>
                            <div>{{dataModel.title}}</div>
                        </div>
                        <div>
                            <label>Cupo</label>
                            <div>{{dataModel.studentLimit ? dataModel.studentLimit : 'Sin límite'}}</div>
                        </div>
                        <div>
                            <label>Inicio de preinscripción</label>
                            <div>{{formatDate(dataModel.startDate)}}</div>
                        </div>
                        <div v-if="dataModel.endDate">
                            <label>Cierre de preinscripción</label>
                            <div>{{formatDate(dataModel.endDate)}}</div>
                        </div>
                    </div>
                    <div>
                        <label>Países</label>
                        <div class="step-5__resume--list">
                            <div v-for="(id,index) in dataModel.countriesIds" :key="index">
                                <i class="material-icons">done</i> <span>{{creationOptions.countries.find(el => el.id == id).name}}</span>
                            </div>
                            <div v-if="!dataModel.countriesIds.length">Todos</div>
                        </div>
                    </div>
                </div>
                <div class="step-5__resume__step-1-2">
                    <div>
                        <label>Tipo de curso</label>
                        <div>{{formattedCourseTypes.find(type => type.id == dataModel.courseType).name}}</div>
                    </div>
                    <div>
                        <label>Público</label>
                        <div>{{formattedTargetTypes.find(type => type.id == dataModel.targetType).name}}</div>
                    </div>
                    <div>
                        <label>Categoría</label>
                        <div>{{creationOptions.categories.find(cat => cat.id == dataModel.categoryId).name}}</div>
                    </div>
                    <div></div>
                    <div>
                        <label>Cursos asociados</label>
                        <div class="step-5__resume--list">
                            <div v-for="(id,index) in dataModel.courses" :key="index">
                                <i class="material-icons">done</i><span>{{creationOptions.courses.find(el => el.id == id).name}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="dataModel.coordinators">
                        <label>Coordinador</label>
                        <div class="step-5__resume--list">
                            <!-- <div v-for="(id,index) in dataModel.coordinators" :key="index">
                                <i class="material-icons">done</i> <span>{{creationOptions.coordinators.find(el => el.id == id)?.fullName}}</span>
                            </div> -->
                            <div>
                                <i class="material-icons">done</i> 
                                <span>{{creationOptions.coordinators.find(el => el.id == dataModel.coordinators)?.fullName}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="dataModel.referents.length > 0">
                        <label>Referentes</label>
                        <div class="step-5__resume--list">
                            <div v-for="(id,index) in dataModel.referents" :key="index">
                                <i class="material-icons">done</i> <span>{{creationOptions.referents.find(el => el.id == id)?.fullName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <h3>DATOS ADICIONALES A SOLICITAR EN LAS ETAPAS DE INSCRIPCIÓN <span @click="stepSelected = 2">Editar <i class="material-icons">edit</i></span></h3>
                <div class="step-5__resume__step-2">
                    <div class="step-5__resume--list step-5__resume--list--nowidth">
                        <div v-if="creationOptions.categories.find(cat => cat.id == dataModel.categoryId)?.fields.length == 0">No solicitará ningún dato para la inscripción</div>
                        <div v-else v-for="(field,index) in creationOptions.categories.find(cat => cat.id == dataModel.categoryId)?.fields" :key="index">
                            <i class="material-icons">done</i>
                            <span>{{ $t('preInscription.fields.' + field.propertyName.toUpperCase()) }}</span>
                        </div>
                    </div>
                </div>
<!--                        <label>Etapa 1 Preinscripción</label>
                         <div class="step-5__resume--list">
                            <template v-for="(data,prop) in dataModel" :key="prop">
                                <div v-if="prop == 'askForCountryStage' && data == 1">
                                    <i class="material-icons">done</i> <span>País</span>
                                </div>
                                <div v-if="prop == 'askForGenderStage' && data == 1">
                                    <i class="material-icons">done</i> <span>Género</span>
                                </div>
                                <div v-if="prop == 'askForPhoneStage' && data == 1">
                                    <i class="material-icons">done</i> <span>Teléfono</span>
                                </div>
                                <div v-if="prop == 'askForDniStage' && data == 1">
                                    <i class="material-icons">done</i> <span>DNI</span>
                                </div>
                                <div v-if="prop == 'askForBirthdateStage' && data == 1">
                                    <i class="material-icons">done</i> <span>Fecha de nacimiento</span>
                                </div>
                                <div v-if="prop == 'askForSchoolNameStage' && data == 1">
                                    <i class="material-icons">done</i> <span>Institución educativa</span>
                                </div>
                            </template>
                            <template v-for="(customField,index) in dataModel.extraData" :key="index">
                                <div v-if="customField.stage == 1">
                                    <i class="material-icons">done</i> <span>{{customField.name}}</span>
                                </div>
                            </template>
                        </div>
                    </div>                   
                    <div>
                        <label>Etapa 2 Inscripción</label>
                        <div class="step-5__resume--list">
                            <template v-for="(data,prop) in dataModel" :key="prop">
                                <div v-if="prop == 'askForCountryStage' && data == 2">
                                    <i class="material-icons">done</i> <span>País</span>
                                </div>
                                <div v-if="prop == 'askForGenderStage' && data == 2">
                                    <i class="material-icons">done</i> <span>Género</span>
                                </div>
                                <div v-if="prop == 'askForPhoneStage' && data == 2">
                                    <i class="material-icons">done</i> <span>Teléfono</span>
                                </div>
                                <div v-if="prop == 'askForDniStage' && data == 2">
                                    <i class="material-icons">done</i> <span>Documento de identidad</span>
                                </div>
                                <div v-if="prop == 'askForBirthdateStage' && data == 2">
                                    <i class="material-icons">done</i> <span>Fecha de nacimiento</span>
                                </div>
                                <div v-if="prop == 'askForSchoolNameStage' && data == 2">
                                    <i class="material-icons">done</i> <span>Institución educativa</span>
                                </div>
                            </template>
                            <template v-for="(customField,index) in dataModel.extraData" :key="index">
                                <div v-if="customField.stage == 2">
                                    <i class="material-icons">done</i> <span>{{customField.name}}</span>
                                </div>
                            </template>
                        </div>
                    </div>                   
                </div>
 -->                <!--<h3>CHARLAS INFORMATIVAS <span @click="stepSelected = 3">Editar <i class="material-icons">edit</i></span></h3>
                <div class="step-5__resume__step-3">
                    <div v-for="(talk,index) in dataModel.talkData" :key="index">
                        <label v-if="index == 0">Charla principal</label>
                        <label v-else>Opción {{index+1}}</label>
                        <div class="step-5__resume--list">
                            <div><i class="material-icons">done</i><span>{{formatDate(talk.talkDate)}}</span></div>
                            <div><i class="material-icons">done</i><span>{{talk.talkHour}} hs</span></div>
                            <div><i class="material-icons">done</i><span>{{talk.talkLink}}</span></div>
                        </div>
                    </div>
                </div>
                <h3>INVITACIÓN <span @click="stepSelected = 4">Editar <i class="material-icons">edit</i></span></h3>
                <div class="step-5__resume__step-4">
                    <div>
                        <label>Modalidad</label>
                        <div>{{creationOptions.modalities.find(el => el.id == dataModel.emailData.modalityId)?.name }}</div>
                    </div>
                    <div>
                        <label>Dedicación</label>
                        <div>{{dataModel.emailData.timeDedication ? dataModel.emailData.timeDedication + ' horas semanales' : 'A definir'}} </div>
                    </div>
                    <div>
                        <label>Duración</label>
                        <div>{{dataModel.emailData.duration ? dataModel.emailData.duration + ' semanas' : 'A definir'}} </div>
                    </div>
                </div> -->
            </div>
            <div class="next-back-btns">
                <button @click.stop="stepSelected = 2"><i class="material-icons">arrow_back</i>Atrás</button>
                <button @click.stop="editingMode ? putData() : postData()">Confirmar<i class="material-icons">arrow_forward</i></button>
            </div>
            <!-- <div class="save-btn"><button>Guardar</button></div> -->
        </div>

        <div class="modal__overlay" v-if="customFieldModel.modalActive">
            <div class="modal modal-customField">
                <div>
                    <h3 style="margin-bottom: 6px;" >Agregar un campo personalizado</h3>
                    <div class="invalid-box-info" v-if="(v$.customFieldModel.name.$invalid || v$.customFieldModel.type.$invalid) && customFieldModel.submitted">
                        <div><i class="material-icons">error</i></div>
                        <div>
                            <div class="invalid-box-info__title">Datos obligatorios</div>
                            <div class="invalid-box-info__info">Completa los campos requeridos para continuar.</div>
                        </div>
                    </div>
                    <Input 
                        v-model="customFieldModel.name"
                        label="Título de campo"
                        :isError=" v$.customFieldModel.name.$invalid && customFieldModel.submitted "
                    />
                    <br />
                    <Multiselect v-model="customFieldModel.type" :options="customFieldTypes" 
                        placeholder="Formato de campo" trackBy="name" valueProp="value" label="name" 
                        :searchable="false" :class="{'invalid-field': v$.customFieldModel.type.$invalid && customFieldModel.submitted}">
                    </Multiselect>
                    <div class="modal-customField__combo-options" v-if="customFieldModel.type == 'SELECT' || customFieldModel.type == 'MULTISELECT'">
                        <div class="modal-customField__combo-options__new">
                            <h4>Crear opciones de respuesta</h4>
                            <input class="input-w-label" type="text" v-model="customFieldModel.newValue" placeholder="Ingresa una opción de respuesta..."
                            :class="{'invalid-field': v$.customFieldModel.values.$invalid && customFieldModel.submitted}">
                            <button class="btn-save" :disabled="customFieldModel.newValue==''" 
                                @click.stop="customFieldModel.newValue == '' ? '' : customFieldModel.values.push(customFieldModel.newValue); customFieldModel.newValue = ''"
                            >+Guardar opción</button>
                        </div>
                        <div class="modal-customField__combo-options__options">
                            <div class="modal-customField__combo-options__option" v-for="(option,index) in customFieldModel.values" :key="index">
                                <span>{{option}}</span><i class="material-icons-outlined" @click.stop="customFieldModel.values.splice(index,1)">delete</i>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal__buttons">
                    <button class="cancel" @click.stop="resetCustomFieldModel()">{{$t('global.CANCEL')}}</button>
                    <button class="confirm" 
                        @click.stop="customFieldModel.index || customFieldModel.index == 0 ? saveChangesCustomField() : addCustomField()"
                        :disabled="v$.customFieldModel.$invalid && customFieldModel.submitted">Crear
                    </button>
                </div>
            </div>
        </div>

        <div class="modal__overlay" v-if="modalDeleteCustomField.active">
            <div class="modal modal-deleteCustomField">
                <h3>¿Estás seguro de eliminar este campo?</h3>
                <div class="modal__buttons">
                    <button class="cancel" @click.stop="modalDeleteCustomField.active=false;modalDeleteCustomField.index=null">{{$t('global.CANCEL')}}</button>
                    <button class="confirm" @click.stop="deleteCustomField()">Eliminar</button>
                </div>
            </div>
        </div>

    </div> <!-- /create-preregistration -->
    <div v-else><Loader/></div>

</template>

<script>
import { onMounted, ref, inject, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '@vuelidate/validators';
import Multiselect from '@vueform/multiselect';
import Loader from '../../components/Loader.vue';
//import ToolTip from '../../components/ToolTip.vue';
import InformationRectangle from '../../components/InformationRectangle.vue';
import Input from '../../components/Input.vue';
import Select from '../../components/Inputs/Select.vue';
import DatePicker from '../../components/Inputs/DatePicker.vue';

export default {
    components: {
    Multiselect,
    Loader,
    //ToolTip,
    InformationRectangle,
    Input,
    Select,
    DatePicker
},
    setup() {
        const showSelectCourses = ref(true)
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const v$ = useVuelidate();
        const { t } = useI18n()
        const formatDate = inject('formatDate');
        const user = computed(() => store.getters.manageUser_user);
        const creationOptions = ref();
        const dataLoaded = ref(false);
        const submitted = ref(false);
        const postingData = ref(false);
        const stepSelected =  ref(1.1);
        const customFieldModel = ref();
        const editingMode = ref(false);
        const canFullEdit = ref(false);
        const editModeLoaded = ref(true)
        const toolTipsHover = ref({
            customFields: false
        })
        const noSelectedCategory = ref(true);

        function updateSelectCourses() {
            showSelectCourses.value = false; 
            dataModel.value.courses = [];

            // set filtered courses
            filterCourses();

            setTimeout(()=>{showSelectCourses.value = true}, 0)
        }
        
        const formattedCourseTypes = computed(() => {
            return creationOptions.value.courseType.map(type => ({
                id: type.id,
                name: t(`course.courseTypes.${type.name}`)
            }));
        });
        const formattedTargetTypes = computed(() => {
            return creationOptions.value.targetType.map(type => ({
                id: type.id,
                name: t(`course.targetTypes.${type.name}`)
            }));
        });


        // const filteredCourses = computed(() => {
        //     if (!dataModel.value.courseType || !dataModel.value.targetType) {
        //         return [];
        //     }
        //     return creationOptions.value.courses.filter(course => 
        //         course.courseType == dataModel.value.courseType && 
        //         course.targetType == dataModel.value.targetType
        //     );
        // });

        const filteredCourses = ref([]);
        function filterCourses(){
            filteredCourses.value = creationOptions.value.courses.filter(course => 
                course.courseType == dataModel.value.courseType && 
                course.targetType == dataModel.value.targetType
            );
        }


        const customFieldTypes = [
            { value:'SHORTSTRING', name: 'Respuesta corta de texto' },
            { value:'NUMBER', name: 'Respuesta corta numérica' },
            { value:'LONGSTRING', name: 'Párrafo libre' },
            { value:'SELECT', name: 'Desplegable de opciones' },
            // { value:'MULTISELECT', name: 'Desplegable con selección multiple' },
            { value:'BOOLEAN', name: 'Si / No' },
            { value:'DATE', name: 'Fecha' }
        ]

        const resetCustomFieldModel = ()=>{
            customFieldModel.value = {
                name: '',
                type: null,
                stage: 1,
                values: [],
                newValue: '',
                modalActive: false,
                submitted: false
            }
        }

        const addNewTalk = () => {
            dataModel.value.talkData.push(
                {
                    talkDate: null,
                    talkHour: null,
                    talkLink: '',
                    talkModality: 'Virtual',
                })
        }

        const deleteTalk = idx => {
            dataModel.value.talkData.splice(idx, 1)
            v$.value.dataModel.talkData.$reset()
        }

        function addCustomField(){
            customFieldModel.value.submitted = true;
            if(v$.value.customFieldModel.$invalid) return;
            let copy = JSON.parse(JSON.stringify(customFieldModel.value));
            delete copy.newValue;
            delete copy.submitted;
            delete copy.modalActive;
            dataModel.value.extraData.push(copy);
            resetCustomFieldModel();
        }

        function editCustomField(field,index){
            let copy = JSON.parse(JSON.stringify(field));
            copy.index = index;
            copy.modalActive = true;
            customFieldModel.value = copy;
        }

        function saveChangesCustomField(){
            customFieldModel.value.submitted = true;
            if(v$.value.customFieldModel.$invalid) return;
            delete customFieldModel.value.newValue;
            delete customFieldModel.value.submitted;
            delete customFieldModel.value.modalActive;
            dataModel.value.extraData.splice(customFieldModel.value.index,1,customFieldModel.value);
            resetCustomFieldModel();
        }

        const modalDeleteCustomField = ref({
            active: false,
            index: null
        })

        function deleteCustomField(){
            dataModel.value.extraData.splice(modalDeleteCustomField.value.index,1);
            modalDeleteCustomField.value.active = false;
            modalDeleteCustomField.value.index = null;
        }

        function clickStageCheckbox(ev,prop,stage,custom=false){
            !custom
                ? dataModel.value[prop] != stage ? dataModel.value[prop] = stage : ev.preventDefault()
                : dataModel.value.extraData[prop].stage != stage ? dataModel.value.extraData[prop].stage = stage : ev.preventDefault();     
        }

        const step1_1Invalid = computed(()=> v$.value.dataModel.title.$invalid || v$.value.dataModel.startDate.$invalid || v$.value.dataModel.internalName.$invalid);
        const step1_2Invalid = computed(() => 
            // v$.value.dataModel.coordinators.$invalid || 
            // v$.value.dataModel.referents.$invalid || 
            v$.value.dataModel.courseType.$invalid || 
            v$.value.dataModel.targetType.$invalid || 
            v$.value.dataModel.courses.$invalid
        );
        /* const step2Invalid = computed(()=> v$.value.dataModel.askForGenderStage.$invalid || 
            v$.value.dataModel.askForCountryStage.$invalid || v$.value.dataModel.askForPhoneStage.$invalid ||
            v$.value.dataModel.askForDniStage.$invalid || v$.value.dataModel.askForBirthdateStage.$invalid || v$.value.dataModel.askForSchoolNameStage.$invalid); */
        const step2Invalid = computed(()=> v$.value.dataModel.categoryId.$invalid && !editingMode.value)
        const step3Invalid = computed(()=> v$.value.dataModel.talkData.$invalid);
        const step4Invalid = computed(()=> v$.value.dataModel.emailData.$invalid);
        const customFieldInvalid = computed(()=> v$.value.customFieldModel.$invalid);

        function submittStep1_1(){
            submitted.value = true;
            if (step1_1Invalid.value) return;
            // dataModel.value.talkData[0].talkTimeZone = dataModel.value.countriesIds.length === 1 && dataModel.value.countriesIds[0] || dataModel.value.talkData[0].talkTimeZone
            stepSelected.value = 1.2;
            submitted.value = false;
        }
        function submittStep1_2(){
            submitted.value = true;
            if (step1_2Invalid.value) return;
            // Remove this line
            // dataModel.value.coordinators = Array.isArray(dataModel.value.coordinators) && dataModel.value.coordinators || [dataModel.value.coordinators];        
            stepSelected.value = 2;
            submitted.value = false;
        }

        function submittStep2(){
            submitted.value = true;
            if(step2Invalid.value) return;
            stepSelected.value = 5;
            submitted.value = false;
        }
        function submittStep3(){
            submitted.value = true;
            if(step3Invalid.value) return;
            stepSelected.value = 4;
            submitted.value = false;
        }
        function submittStep4(){
            submitted.value = true;
            if(step4Invalid.value) return;
            stepSelected.value = 5;
            submitted.value = false;
        }

        async function postData(){
            postingData.value = true;
            dataModel.value.emailData = {}

            // Ensure coordinators is an array of valid IDs
            if (dataModel.value.coordinators != null) {
                dataModel.value.coordinators = Array.isArray(dataModel.value.coordinators)
                    ? dataModel.value.coordinators.filter(id => id != null)
                    : [dataModel.value.coordinators].filter(id => id != null);
            } else {
                dataModel.value.coordinators = [];
            }

            // Create a shallow copy of dataModel.value
            let dataToSend = { ...dataModel.value };

            // Handle coordinators
            if (!dataToSend.coordinators) {
                delete dataToSend.coordinators;
            }

            // Handle referents (assuming it's an array)
            if (Array.isArray(dataToSend.referents)) {
                dataToSend.referents = dataToSend.referents.filter(id => id != null);
                if (dataToSend.referents.length === 0) {
                    delete dataToSend.referents;
                }
            } else {
                delete dataToSend.referents;
            }

            try {
                let req = await store.dispatch('preInscription_postPreInscription', dataToSend);
                console.log(req.data);
                router.push(req.data.courseType == 1 ? `/createcourses/${req.data.id}` : '/management/preinscriptions');
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al intentar crear preinscripción' });
            } finally {
                postingData.value = false;
            }
        }



        async function putData(){
            postingData.value = true;
            dataModel.value.emailData = {}

            // Ensure coordinators is an array of valid IDs
            if (dataModel.value.coordinators != null) {
                dataModel.value.coordinators = Array.isArray(dataModel.value.coordinators)
                    ? dataModel.value.coordinators.filter(id => id != null)
                    : [dataModel.value.coordinators].filter(id => id != null);
            } else {
                dataModel.value.coordinators = [];
            }

            // Create a shallow copy of dataModel.value
            let dataToSend = { ...dataModel.value };

            // Handle coordinators
            if (!dataToSend.coordinators) {
                delete dataToSend.coordinators;
            }

            // Handle referents (assuming it's an array)
            if (Array.isArray(dataToSend.referents)) {
                dataToSend.referents = dataToSend.referents.filter(id => id != null);
                if (dataToSend.referents.length === 0) {
                    delete dataToSend.referents;
                }
            } else {
                delete dataToSend.referents;
            }
            
            
            try {
                await store.dispatch('preInscription_editPreInscription',{id: route.params.id, data: dataModel.value});
                router.push('/management/preinscriptions')
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create',{text: 'Error al intentar editar la preinscripción'})
            } finally{
                postingData.value = false;
            }
        }

        const dataModel = ref();
        const cleanDataModel = () => {
            dataModel.value = {
                title: '',
                internalName: '',
                startDate: null,
                endDate: null,
                studentLimit: null,
                courseType: null,
                targetType: null,
                courses: [],
                categoryId: null,
                coordinators: [],
                referents: [],
                countriesIds: [],
                talkData: [
                    // {
                    //     talkDate: null,
                    //     talkHour: null,
                    //     talkLink: '',
                    //     talkModality: 'Virtual',
                    // }
                ],
                emailData: {
                    emailInfo: '',
                    modalityId: null,
                    timeDedication: null,
                    duration: null,
                    courseStartDate: null
                },
                behaviourOnClose : 'MANUAL',
                askForGenderStage: 1,
                askForCountryStage: 1,
                askForPhoneStage: 1,
                askForDniStage: 1,
                askForBirthdateStage: 1,
                askForSchoolNameStage: 1,
                extraData: []
            }
        }

        async function getCreationOptions(){
            try {
                let req = await store.dispatch('preRegistration_creationOptions');
                creationOptions.value = req.data;
                dataModel.value.coordinators = creationOptions.value.coordinators.map(coordinator => coordinator.id).filter(coordinator => coordinator === user.value.id)[0]
                dataModel.value.referents = creationOptions.value.referents.map(referent => referent.id).filter(referent => referent === user.value.id)
                creationOptions.value.customFieldTypes = customFieldTypes;
                creationOptions.value.courses.push({ id: null, name: 'A definir', internalName: 'A definir', courseType: 0 });
                creationOptions.value.modalities = creationOptions.value.modalities.filter(modality => modality.name !== 'Presencial' && modality.name !== 'Mixto')
                filteredCourses.value = creationOptions.value.courses;
                dataLoaded.value = true;                
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar opciones de creación' });
            }
        }
        async function editMode(){
            try {
                editModeLoaded.value = false
                let req = await store.dispatch('preInscription_getPreInscription', route.params.id)
                dataModel.value = req.data;
                dataModel.value.coordinators = dataModel.value.coordinators[0] 
                if(!dataModel.value.courses.length) dataModel.value.courses.push(null);
                editingMode.value = true;
                canFullEdit.value = dataModel.value.canFullEdit
                editModeLoaded.value = true
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al obtener datos de preinscripción' });
            }
        }  


        onMounted(async()=>{
             resetCustomFieldModel();
             cleanDataModel()
             await getCreationOptions()
             if(route.name == 'EDIT_PREINSCRIPTION') await editMode();

            // if editingMode filter courses
            if(editingMode.value){
                // updateSelectCourses();
                filterCourses();
                // Maintain selected courses
                dataModel.value.courses = dataModel.value.courses.filter(courseId => 
                    filteredCourses.value.some(course => course.id === courseId)
                );
            }
        })
        
        return  {
            showSelectCourses,
            updateSelectCourses,
            v$,
            user,
            dataModel,
            creationOptions,
            dataLoaded,
            postData,
            putData,
            customFieldModel,
            customFieldTypes,
            resetCustomFieldModel,
            addCustomField,
            editCustomField,
            saveChangesCustomField,
            modalDeleteCustomField,
            deleteCustomField,
            clickStageCheckbox,
            submitted,
            cleanDataModel,
            stepSelected,
            formatDate,
            submittStep1_1,
            submittStep1_2,
            submittStep2,
            submittStep3,
            submittStep4,
            step1_1Invalid,
            step1_2Invalid,
            step2Invalid,
            step3Invalid,
            step4Invalid,
            customFieldInvalid,
            postingData,
            editingMode,
            toolTipsHover,
            canFullEdit,
            editModeLoaded,
            addNewTalk,
            deleteTalk,
            formattedCourseTypes,
            formattedTargetTypes,
            filteredCourses,
            filterCourses,
            noSelectedCategory
        }
    },
    validations() {
        // const isValidUrl = urlString => {
        //     const urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
        //         '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
        //         '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
        //         '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
        //         '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        //         '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
        //     return !!urlPattern.test(urlString);
        // }
        return{
            dataModel: {
                title : { required },
                internalName: { required },
                startDate: { required },
                // coordinators: { required },
                // referents: { required },
                courseType: { required },
                targetType: { required },
                courses: { required },
                categoryId: { required },
                // talkData: {
                //     $each: helpers.forEach({
                //         talkDate: { required },
                //         talkHour: { required },
                //         talkLink: { required, isValidUrl },
                //     }),
                // },
                emailData: {
                    emailInfo: { required },
                    modalityId: { required },
                },
                askForDniStage: { required },
                askForGenderStage: { required },
                askForCountryStage: { required },
                askForPhoneStage: { required },
                askForBirthdateStage: { required },
                askForSchoolNameStage: { required },
            },
            customFieldModel: {
                name: { required },
                type: { required },
                values: { 
                    requiredIfTypeCombo:  requiredIf( ()=> this.customFieldModel.type == 'SELECT' || this.customFieldModel.type == 'MULTISELECT' ), 
                }
            }
        }
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss">
@import '@/styles/main.scss';
.modal-customField{
    .multiselect-option{
        &::before{
            font-family: "Material Icons Outlined";
            padding-right: 10px;
            font-size: 18px
        }
        &:nth-child(1){
            &::before{
                content: "short_text";
            }
        }
        &:nth-child(2){
            &::before{
                content: "short_text";
            }
        }
        &:nth-child(3){
            &::before{
                content: "notes";
            }
        }
        &:nth-child(4){
            &::before{
                content: "expand_circle_down";
            }
        }
        &:nth-child(5){
            &::before{
                content: "expand_circle_down";
            }
        }
        &:nth-child(6){
            &::before{
                content: "check_box";
            }
        }
        &:nth-child(7){
            &::before{
                content: "calendar_month";
            }
        }
        &.is-selected{
            background: $green;
        }
    }
}
</style>
<style lang="scss" scoped>
@import '@/styles/main.scss';
.editDisabled{
    *{
        opacity: .6;
        cursor: default !important;
    }
}
.multiselect{
    border: none;
    height: 50px;
    padding: 0 12px;
    background: #F6F6F6;
    border-radius: 50px;
}

.create-preregistration{
    width: 100%;
    min-height: 100vh;
    padding-bottom: 49px;
    @include flex-column;
    background: #fff;
}

.header-steps{
    width: 100%;
    margin-bottom: 32px;
    height: 86px;
    padding-bottom: 18px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 42px;
    border-bottom: 1px solid #D9D9D9;
    background: #fff;
    .step{
        @include icon-and-text-container;
        span:first-child{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            border-radius: 100%;
            background: #BDBDBD;
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            line-height: 28px;
        }
        span:last-child{
            font-size: 13px;
            font-weight: 600;
            color: #BDBDBD;
        }
        &--selected{
            span:first-child{
                background: #FFB23F;
                color: #212121;
            }
            span:last-child{
                color: #212121;
            }
        }
        .material-icons{
            color: #77C991;
            font-size: 29px
        }
    }
}

.btn-customField{
    margin: 6px 0;
    text-align: left;
    font-size: 12px;
    color: var(--green);
    font-weight: 600;
}
.place{
    box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px;
    &__title{
        font-weight: 700;
        font-size: 12px;
    }
}

.form-header{
    @include flex-column;
    gap: 12px;
    h1{
        font-size: 24px;
        font-weight: 800;
    }
    h2{
        font-size: 14px;
        font-weight: 800;
    }
    h3{
        font-size: 20px;
        font-weight: 600;
    }

    &__instructions{
        padding: 16px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 500;
        // color: #BDBDBD;

        &.disabled {
            opacity: 0.5;
        }
        i {
            font-size: 16px;
            color: $green;
            // color: #BDBDBD;
        }
    }
}

.input-w-label{
    height: 50px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F6F6F6;
    border-radius: 50px;
    border: none;
    label{
        padding-right: 6px;
        background: #F6F6F6;
        font-size: 13px;
        font-weight: 400;
    }
    input{
        background: #F6F6F6;
        border: none;
        flex-grow: 1;
    }
}

.next-back-btns{
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding-top: 36px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    button{
        flex-grow: 1;
        min-width: 48%;
        padding: 13px 0;
        @include icon-and-text-container;
        justify-content: center;
        background: $green;
        border-radius: 44px;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        &:first-child{
            background: #fff;
            color: $green;
            border: 1px solid $green;
        }
        .material-icons{
            font-size: 18px;
        }
    }
}

.save-btn{
    width: 100%;
    padding-top: 24px;
    display: flex;
    justify-content: center;
    button{
        font-size: 16px;
        font-weight: 600;
        color: $green;
        cursor: default;
    }
}

.hide-date{ 
    flex-grow: 0 !important;
    &::-webkit-datetime-edit{
        display: none;
    }
}

.step-1-1,.step-1-2{
    width: 98vw;
    max-width: 400px;
    &__form{
        padding: 22px 0 0 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
        h5{
            padding-top: 4px;
            font-size: 13px;
            font-weight: 700;
        }
        &__onClose{
            display: flex;
            gap: 24px;
            >div{
                display: flex;
                gap: 8px;
            }
        }
        .info-label-date{
            @include icon-and-text-container;
            font-weight: 600;
            font-size: 10px;
            .material-icons{
                font-size: 19px;
            }
        }
    }
    .btn-nextStep{
        width: 100%;
        padding: 13px 0;
        @include icon-and-text-container;
        justify-content: center;
        background: $green;
        border-radius: 44px;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        .material-icons{
            font-size: 18px;
        }
    }
}

.step-2__info,.invalid-box-info{  
    margin: 16px 0;
    padding: 14px 20px;
    display: flex;
    align-items: stretch;
    background: rgba(255, 189, 176, 0.5);;
    >div{
        display: flex;
        flex-direction: column;
        &:first-child{
            width: fit-content;
            .material-icons{
                padding-right: 6px;
                color: $red;
            }
        }
        &:last-child{
            flex-grow: 1;
            gap: 12px;
            font-size: 14px;
        }
    }
    &__title{
        padding-top: 2px;
        font-weight: 700;
        color: $red;
    }
    &__info{
        font-weight: 500;
    } 
}

.step-2{
    width: fit-content;
    .form-header{
        padding-bottom: 18px;
        h3{
            font-size: 18px;
        }
        h4{
            font-size: 15px;
            font-weight: 500;
        }
    }
    &__info{
        background: #DEF1F1;
        >div:first-child{
            .material-icons{
                color: #0A5078;
            }
        }
        &__title{
            color: #0A5078;
        }
    }
    // .select-category-table{
    //     margin: 16px 0;
    //     // padding: 8px 8px 22px 16px;
    //     box-shadow: (0px 4px 4px 0px rgba(0, 0, 0, .10));
    //     .header, .row{
    //         display: flex;
    //         justify-content: center;
    //         span{
    //             width: 87px;
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //             gap: 5px;
    //             font-size: 12px;
    //             text-align: center;
    //         }
    //     }
    //     .header{
    //         // padding-bottom: 6px;
    //         span{
    //             font-weight: 700;
    //         }
    //     }
    //     .row{
    //         border: 1px solid #DEDEDE;
    //         opacity: .5;

    //         &__selected{
    //             opacity: 1;
    //         }

    //         &__name {
    //             &__check {
    //                 background-color: transparent;
    //                 width: 20px;
    //                 height: 20px;

    //                 &--selected {
    //                     background-color: red;
    //                 }
    //             }
    //         }
    //         // span{
    //         //     height: 46px;
    //         //     // border-bottom: 1px solid #DEDEDE;
    //         //     &.row__name{
    //         //         width: 30px;
    //         //         justify-content: flex-start;
    //         //         border-bottom: none;
    //         //         font-weight: 600;
    //         //     }
    //         // }
    //     }
    // }

    .select-category-table {
        // tr, th, td {
        //     border: 1px solid #DEDEDE;
        //     // border-collapse: collapse;
        //     // padding: 8px;
        //     // text-align: center;
        // }
        // no space
        border-collapse: collapse;
        // border: 1px solid #DEDEDE;
        border-radius: 8px;
        overflow: hidden;

        &.disabled {
            opacity: 0.5;
        }

        &.noSelectedCategory {
            // background:red!important;

            // animate body rows outline one by one from top to bottom infinite
            tbody {
                tr {
                    $duracion_animacion: 1s;
                    $retraso_entre_animaciones: 0.1s;

                    // border: 1px solid #DEDEDE;
                    outline-width: 1px;
                    outline-style: solid;
                    outline-color: #DEDEDE;
                    outline-offset: -1px;
                    animation: animateOutline $duracion_animacion ease-in-out forwards;

                    // animation: animateOutline 1s infinite;



                    @for $i from 1 through 20 {
                        &:nth-child(#{$i}) {
                            animation-delay: ($i - 1) * ($duracion_animacion + $retraso_entre_animaciones);
                        }
                    }

                    @keyframes animateOutline {
                        0% {
                            outline-color: #DEDEDE;
                        }
                        50% {
                            outline-color: $green;
                        }
                        100% {
                            outline-color: #DEDEDE;
                        }
                    }


                }
            }
        }
        
        th, td {
            padding: 8px 16px;
            max-width: 124px;
            text-align: center;
        }
        thead {
            th {
                // background-color: #F6F6F6;
                font-size: 13px;
                font-weight: 600;
            }
        }
        tbody {
            // border-radius: 8px;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);


            tr {
                // border: 1px solid #DEDEDE;
                outline-width: 1px;
                outline-style: solid;
                outline-color: #DEDEDE;
                outline-offset: -1px;

                &:first-child {
                    border-top-left-radius: 8px;
                    border-top-right-radius: 8px;
                }

                &:last-child {
                    border-bottom-left-radius: 8px;
                    border-bottom-right-radius: 8px;
                }

                &.row__selected {
                    // border: 1px solid $green;
                    outline-color: $green;
                    background-color: #d6f1f1;
                }
                td {
                    font-size: 14px;
                    font-weight: 400;
                    padding: 16px;

                    i {
                        font-size: 20px;
                        color: $green;
                    }
                    .empty {
                        color: #949494;
                        font-size: 20px;
                        line-height: 16px;
                    }

                    // row__name__check row__name__check--selected
                    .row__name__check {
                        background-color: transparent;
                        width: 20px;
                        height: 20px;
                        border: 2px solid $green;
                        border-radius: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        &--selected {
                            background-color: $green;

                            // i {
                            //     color: white;
                            //     font-size: 12px;
                            // }
                            span {
                                width: 10px;
                                height: 10px;
                                border-radius: 100px;
                                background-color: white;
                            }
                        }
                    }
                }
            }
        }

    }
    .stages{
        display: flex;
        justify-content: space-evenly;
        margin-top: 18px;
        >div{
            width: 33%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            label,input{
                font-size: 14px;
                height: 15px;
            }
        }
        &__labels{
            align-items: flex-start !important;
        }
        .stage-title{
            height: 54px;
            @include flex-column;
            font-size: 14px;
            font-weight: 400;
            span:last-child{
                font-weight: 600;
            }
        }
        .btn-customField{
            margin: 6px 0;
            text-align: left;
            font-size: 12px;
            color: $green;
            font-weight: 600;
        }
        .custom-field{
            display: flex;
            align-items: center;
            gap: 12px;
            span{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 14px;
            }
            .material-icons-outlined{
                cursor: pointer;
                font-size: 20px;
            }
        }
    }
    .invalid-field{
        border: none;
        &--input{
            border: 2px solid $red !important;
        }
    }
}

.step-4{
    width: 98vw;
    max-width: 540px;
    &__form{
        padding: 36px 0 20px 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
        &__email-content{
            display: flex;
            flex-direction: column;
            label{
                padding-bottom: 12px;
                font-size: 14px;
                font-weight: 700;
            }
            textarea{
                width: 100%;
                height: 160px;
                padding: 6px 8px;
                resize: vertical;
                border-radius: 16px;
                background: #F6F6F6;
                border: none;
                outline: none;
                &.invalid-field{
                    border: 1px solid $login-error-color;                
                }
            }
        }
    }
}

.step-5{
    width: 98vw;
    max-width: 710px;
    &__resume{
        width: 100%;
        padding: 28px 0 14px 0;
        h3{
            font-size: 12px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span{
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 6px;
                color: $green;
                .material-icons{
                    font-size: 16px;
                }
            }
        }
        &--list{
            >div{
                @include icon-and-text-container;
                .material-icons{
                    font-size: 18px;
                }
            }
            &--nowidth{
                max-width: unset!important;
            }
        }
        &__step-1-1,&__step-1-2,&__step-2,&__step-3,&__step-4{
            margin: 12px 0 22px 0;
            padding: 12px 22px 18px 22px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            border-radius: 10px;
            box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
            >div{
                width: 100%;
                max-width: 205px;
                padding-top: 8px;
                display: flex;
                flex-direction: column;
                gap: 6px;
                label{
                    font-weight: 600;
                    font-size: 12px;
                }
                div{
                    font-weight: 400;
                    font-size: 12px;
                }
            }
        }
        &__step-1-1{
            >div:first-child{
                flex-grow: 1;
                max-width: 446px;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                >div{
                    width: 100%;
                    max-width: 205px;
                    padding-top: 8px;
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    label{
                        font-weight: 600;
                        font-size: 12px;
                    }
                    div{
                        font-weight: 400;
                        font-size: 12px;
                    }
                }
            }
        }
        &__step-1-2{
            gap: 6px;
        }
        &__step-2{
            justify-content: flex-start;
            gap: 24px;
        }
    }
}

@mixin modals{
    padding: 36px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
    h3{
        font-weight: 700;
        font-size: 20px;
    }
    .modal__buttons{
        justify-content: flex-end;
        gap: 40px;
        font-weight: 600;
        font-size: 16px;
        .cancel{
            border: none;
        }
        .confirm{
            width: fit-content;
            height: 45px;
            padding: 0 42px;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
            border-radius: 44px;
        }
    }
}

.modal-deleteCustomField{
    @include modals;
    max-width: 420px;
    .modal__buttons{
        .confirm{
            background: map-get($secondary, 500);
        }
    }

}

.modal-customField{
    @include modals;
    justify-content: space-between;
    //gap: 24px;
    max-width: 556px;
    height: fit-content;
    min-height: 400px;
    max-height: 90vh;
    input,.multiselect{
        width: 100%;
        min-height: 50px;
    }
    input{
        margin: 16px 0;
    }
/*     .select-container{
        position: relative;
        .select-arrow{
            position: absolute;
            right: 12px;
            top: 16px;
            color: black;
            pointer-events:none;
        }
    }
    select{
        appearance: none;
        cursor: pointer;
    }
 */    &__combo-options{
        padding-top: 12px;
        &__new{
            h4{
                padding: 16px 0 8px 10px;
                font-size: 13px;
                font-weight: 600;
            }
            input{
                margin: 0;
            }
            .btn-save{
                padding: 6px 0 10px 6px;
                font-size: 13px;
                cursor: pointer;
                color: $green;
                font-weight: 500;
                &:disabled{
                    cursor: default;
                }
            }
        }
        &__options{
            padding: 4px 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }
        &__option{
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 14px;
            .material-icons-outlined{
                font-size: 18px;
                color: red;
                cursor: pointer;
            }
        }
    }
}

.invalid-field{
    color: $login-error-color;
    *{
        color: $login-error-color;
    }
    border: 1px solid $login-error-color;
}

.invalid-message {
    margin-top: 4px;
    @include icon-and-text-container;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    color: $login-error-color;
    .material-icons{
        font-size: 16px;
    }
}

.multiselect-wrapper {
    margin-bottom: 0;
}
.greyed-out:checked{
    pointer-events: none;
    opacity: 0.4;
}

</style>
